export class ServiceTypeModel {
    id: number;
    description: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/service-type.model.ts